/**
 * impleco contact form
 * https://impleco.atlassian.net/browse/WISCH-70
 */

import React, { useEffect, useState } from 'react';
import Checkbox from '../MaterialUi/Checkbox';
import Select, { ISelectProps } from '../MaterialUi/Select';
import TextField from '../MaterialUi/TextField';
import { IConcreteContactFormProps } from './ContactForm';
import styles from './ContactForm.scss'
import Button from '../MaterialUi/Button';



const Kooperationsanfrage: React.FC<React.PropsWithChildren<IConcreteContactFormProps>> = ({ onSubmit }) => {

    const [formValues, setFormValues] = useState({ timestamppreventduplicates: `${Date.now()}_${Math.random()}`, id_wgn_form: 'Kooperationsanfrage' })

    const onChange = (ev) => {
        const name = ev.target.name;
        const value = ev.target.value || ev.target.checked;
        setFormValues(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();
        onSubmit(formValues).then(() => {
            setFormValues({ timestamppreventduplicates: `${Date.now()}_${Math.random()}`, id_wgn_form: 'Kooperationsanfrage' })
        }
        )
    }

    return (
        <fieldset className={styles.contactForm}>
            <h2>Ihre Kooperationsanfrage an Wohnglück</h2>
            <form onSubmit={handleSubmit}>


                <TextField multiline label="Was möchten Sie uns mitteilen?" onChange={onChange} required={true} placeholder="Hier können Sie Ihre Kooperationsanfrage ausführlich beschreiben (max. 1.200 Zeichen)" name="mitteilungstext" />

                <Select onChange={onChange} value={formValues['anrede']} label="Anrede" name="anrede">
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                    <option value="Divers">Divers</option>
                </Select>

                <TextField onChange={onChange} value={formValues['firma'] || ''} name="firma" label="Firma" type="text" />

                <TextField onChange={onChange} value={formValues['vorname'] || ''} name="vorname" label="Vorname" required={true} type="text" />

                <TextField onChange={onChange} value={formValues['nachname'] || ''} name="nachname" label="Nachname" required={true} type="text" />

                <TextField onChange={onChange} value={formValues['strasse'] || ''} name="strasse" label="Straße" type="text" />

                <TextField onChange={onChange} value={formValues['hausnummer'] || ''} name="hausnummer" label="Hausnummer" type="text" />

                <TextField onChange={onChange} value={formValues['plz'] || ''} name="plz" label="PLZ" type="text" />

                <TextField onChange={onChange} value={formValues['ort'] || ''} name="ort" label="Ort" type="text" />

                <TextField onChange={onChange} value={formValues['telefon_vorwahl'] || ''} name="telefon_vorwahl" label="Telefon-Vorwahl" type="text" />

                <TextField onChange={onChange} value={formValues['telefon_rufnummer'] || ''} name="telefon_rufnummer" label="Telefon-Rufnummer" type="text" />

                <TextField 
                    onChange={onChange} 
                    value={formValues['email'] || ''} 
                    name="email" 
                    required={true} 
                    label="E-Mail" 
                    type="email" 
                    inputProps={{
                        autoComplete: "email",
                    }}
                />

                <h4>
                    Datenverwendung und Datenschutz<span className="mandatory">*</span>
                </h4>
                <div className={styles.terms}>
                    <Checkbox onChange={onChange} label={
                        <>
                            Hiermit willige ich ein, dass meine personenbezogenen Daten zum Zwecke und für die Dauer der Bearbeitung meiner Kooperationsanfrage gespeichert werden.
                            Nähere Angaben zum Umgang mit meinen personenbezogenen Daten und zu meinen Rechten finde ich in der
                            {' '}<b><a href="https://wohnglueck.de/info/datenschutz" target="_blank">Datenschutzerklärung</a></b>.
                        </>
                    } required name="datenverwendungunddatenschutz" value={formValues['datenverwendungunddatenschutz']} />
                </div>

                <div className={styles.thanks}>
                    Vielen Dank, dass Du die mit * markierten Pflichtfelder ausfüllst.
                </div>

                <div className={styles.actions}>
                    <Button type="submit" color="primary">Anfrage absenden</Button>
                </div>
            </form>

        </fieldset>
    );
};

export default Kooperationsanfrage;
